import { Grid, Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ChevronRight } from "@material-ui/icons";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useQuery } from "@tanstack/react-query";
import { useHistory } from "../../../shared/hooks/useHistory";
import { EmptyDetailsState } from "../../../components";
import { getParticipantLessonCollectables } from "../../../learning-path/learningPath.service";
import { Button } from "../../../shared/components/button";
import { LessonCollectible } from "../../../shared/components/lesson-collectible";
import { sectionLessons } from "./lessons-in-collectibles.consts";
import { lessonsInCollectiblesStyles } from "./lessons-in-collectibles.styles";

const PAGE_SIZE = 3;

type Props = {
  filterBy?: string;
  hideOnEmptyFilterResult?: boolean;
};

export const LessonsInCollectibles = ({
  filterBy,
  hideOnEmptyFilterResult,
}: Props) => {
  const history = useHistory();
  const classes = lessonsInCollectiblesStyles();

  const { data, isFetching } = useQuery({
    queryKey: ["lessons-in-collectibles", filterBy],
    queryFn: () =>
      getParticipantLessonCollectables({
        keyword: filterBy,
        pageNumber: 1,
        pageSize: PAGE_SIZE,
      }),
    refetchOnWindowFocus: false,
  });

  const handleButtonClick = () => history.push("/participant/lessons");

  const showCTAButtons = !isFetching && !data?.totalRecords && !filterBy;
  const showViewMoreButtons =
    (!isFetching && data?.totalRecords > PAGE_SIZE) || filterBy;
  // TODO: Delete this after Lessons page is ready
  const disabledButtons = true;

  if (hideOnEmptyFilterResult && filterBy && !data?.totalRecords) {
    return null;
  }

  return (
    <Grid container item>
      <Grid item container justifyContent="space-between">
        <Typography className={classes.header}>
          {sectionLessons.header}
          <InfoOutlinedIcon className={classes.infoIcon} />
        </Typography>
        {!disabledButtons && showViewMoreButtons && (
          <Button
            variant="outlined"
            className={classes.viewMoreBtn}
            endIcon={<ChevronRight />}
            onClick={handleButtonClick}
          >
            View more
          </Button>
        )}
      </Grid>
      <Grid container className={classes.contentContainer}>
        {isFetching ? (
          <CircularProgress />
        ) : !data?.totalRecords ? (
          <EmptyDetailsState
            className={classes.emptyState}
            title={sectionLessons.title}
            imageUrl={sectionLessons.imageUrl}
            description={sectionLessons.description}
            action={
              !disabledButtons && showCTAButtons ? (
                <Button
                  variant="outlined"
                  className={classes.button}
                  onClick={handleButtonClick}
                >
                  {sectionLessons.buttonText}
                </Button>
              ) : null
            }
          />
        ) : (
          data?.data.map((lesson) => (
            <Grid
              item
              key={lesson.slideId}
              md={4}
              className={classes.container}
            >
              <LessonCollectible
                slideId={lesson.slideId}
                categoryName={lesson.categoryName}
                title={lesson.title}
                imagePath={lesson.imagePath}
                date={new Date(lesson.createdAt)}
              />
            </Grid>
          ))
        )}
      </Grid>
    </Grid>
  );
};
